export interface OtpModel {
  mobileNumber: string;
  register: boolean;
  authtype: number;
  phoneCountryId: number;
}
